export default __webpack_public_path__ + "static/media/github.f7165d3e.svg";